import { module } from 'modujs';
import 'select2/dist/js/select2.min.js';
import 'select2/dist/css/select2.min.css';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
          click: {
            toggleActive: 'toggleActive',
            toggleCheckbox: 'toggleCheckbox',
          },
          focusin: {
            input: 'active',
          },
          focusout: {
            input: 'desactive',
          },
          keypress: {
            enter: 'enter',
          },
        }
    }

    init() {
      let select2 = this.$('select2');
        let placeholder = 'Choisir';
        if(select2) {
          select2.forEach(element => { 
              if(element.getAttribute('data-placeholder')) {
                  placeholder = element.getAttribute('data-placeholder');
              }
              $(element).select2({
                  placeholder: placeholder,
                  allowClear: true,
              });
              // $('#'+element.getAttribute('id')).on('change.select2', function() {
              //     $this.call('refresh', false, 'Filtres');
              // });
          });
      }
    }

    active(e) {
      const target = e.currentTarget;
      const item = this.parent('item', target);
      item.classList.add('is-active');
    }

    desactive(e) {
      const target = e.currentTarget;
      const item = this.parent('item', target);
      if(target.value == "") {
        item.classList.remove('is-active');
      }
    }

  toggleActive(e) {
    let el = e.currentTarget;
    el.classList.toggle('is-active');
  }

  toggleCheckbox(e) {
    let el = e.currentTarget;
    const items = this.$('toggleActive');
    items.forEach(element => { 
      let id = $(element).attr('data-id');
      if($(element).attr('class').indexOf('is-active') != -1) {
        $('input#'+id).prop('checked', true);
      }else {
        $('input#'+id).prop('checked', false);
      }
    });

    this.call('close', false, 'Modal');

    if($(el).attr('data-form')) {
      let form = $(el).attr('data-form');
      $(form).submit();
    }

    if($(el).attr('data-refresh')) {
      this.call('change', false, 'Filtres');
    }
  }

  initActive() {
    let items = this.$('toggleActive');
    if(items.length) {
      items.forEach(element => { 
        let id = element.getAttribute('data-id');
        if($('#'+id).is(':checked')) {
          element.classList.toggle('is-active');
        }
      });
    }
  }

  enter(e) {
    if(e.key == 'Enter') {
      let el = e.currentTarget;
        e.preventDefault();
        $(el).parents('form').find('button').trigger('click');
    }
  }
}
